import bowser from 'bowser';

export const deviceSize = {
  cardwidthp: 480,
  cardwidthpt: 736,
  cardwidtht: 860,
  cardwidthsm: 992,
  cardwidthm: 1200,
  cardwidthxl: 1366
};

export const cardSize = {
  cardwidthp: '100%',
  cardwidthpt: '90%',
  cardwidtht: '95%',
  cardwidthsm: 840,
  cardwidthm: 940,
  cardwidthxl: 940
};

export const addClass = (_element, className) => {
  const element = _element;
  var classes = (element.className || '').split(' ').filter(p => {
    return p;
  });

  if (classes.indexOf(className) > -1) return;

  classes.push(className);
  element.className = classes.join(' ');
};

export const removeClass = (_element, className) => {
  const element = _element;
  if (element && element.className && typeof element.className === 'string') {
    var classes = element.className.split(' ').filter(p => {
      return p && p !== className;
    });
    element.className = classes.join(' ');
  }
};

export const setAttribute = (_element, attr, value) => {
  const element = _element;
  if (element && element.setAttribute && typeof element.setAttribute === 'function') {
    element.setAttribute(attr, value);
  }
};

export const removeAttribute = (_element, attr) => {
  const element = _element;
  if (element && element.setAttribute && typeof element.removeAttribute === 'function') {
    element.removeAttribute(attr);
  }
};

export const hasClass = (element, className) => {
  if (element.className && typeof element.className === 'string') {
    var classes = element.className.split(' ');
    return classes.indexOf(className) > -1;
  }
};

export const toggleClass = (element, className) => {
  if (element) {
    if (!hasClass(element, className)) {
      return addClass(element, className);
    }
    return removeClass(element, className);
  }
};

export const isDescendant = (parent, child) => {
  const node = child.parentNode;

  if (node === null) return false;

  return node === parent ? true : isDescendant(parent, node);
};

export const forEach = (arr, fn) => {
  Array.prototype.forEach.call(arr, fn);
};

export const map = (arr, fn) => {
  return Array.prototype.map.call(arr, fn);
};

export const reduce = (arr, fn, initialValue) => {
  return Array.prototype.reduce.call(arr, fn, initialValue);
};

export const hasTouch = () => {
  var isTesting = global.location.hostname === 'www.jotform.ooo';
  /* eslint-disable */
  var deviceHasTouch = !!(('ontouchstart' in window) || window.navigator && window.navigator.maxTouchPoints > 0 && window.navigator.msMaxTouchPoints > 0 && window.navigator.msPointerEnabled && window.MSGesture || window.DocumentTouch && document instanceof DocumentTouch) && !isTesting;
  /* eslint-enable */

  if (deviceHasTouch) {
    var formWrapper = document.querySelector('.jfForm-wrapper');
    addClass(formWrapper, 'hasTouch');
  }

  return deviceHasTouch;
};

export const isVisible = elem => {
  if (!(elem instanceof window.Element)) throw Error('DomUtil: elem is not an element.');
  const style = window.getComputedStyle(elem);
  if (style.display === 'none') return false;
  if (style.visibility !== 'visible') return false;
  if (style.opacity < 0.1) return false;
  if (elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height
    + elem.getBoundingClientRect().width === 0) {
    return false;
  }
  const elemCenter = {
    x: elem.getBoundingClientRect().left + (elem.offsetWidth / 2),
    y: elem.getBoundingClientRect().top + (elem.offsetHeight / 2)
  };
  if (elemCenter.x < 0) return false;
  if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) return false;
  if (elemCenter.y < 0) return false;
  if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) return false;
  let pointContainer = document.elementFromPoint(elemCenter.x, elemCenter.y);

  while (pointContainer !== null) {
    if (pointContainer === elem) return true;
    pointContainer = pointContainer.parentNode;
  }
  return false;
};

export const debounce = (func, wait, immediate) => {
  var timeout;
  return (...params) => {
    const context = this;
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, params);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, params);
  };
};

export const makeHiddenSubmissionKey = formID => {
  return `jfHiddenSubmission_${formID}`;
};

export function createSubmissionToken(formID) {
  const random = Math.floor(Math.random() * (99 - 1)) + 1;
  const ticks = new Date().getTime();
  const formIDPart = formID.toString().substr(0, 5);
  return `jf_${formIDPart}${ticks}${random}`;
}

export function createInput(props) {
  const input = global.document.createElement('input');
  const keys = Object.keys(props);
  for (let i = 0; i < keys.length; i++) {
    const prop = keys[i];
    input[prop] = props[prop];
  }
  return input;
}

export function getInputValidations(input) {
  return input.className.replace(/.*validate\[(.*)].*/, '$1').split(/\s*,\s*/);
}

export function fuzzySearch(_searchItem, itemArray) {
  const mailProviders = itemArray;
  const completeValue = _searchItem.split('');
  const searchItem = _searchItem;

  const checkList = [];

  for (let index = 1; index <= completeValue.length; index++) {
    const firstPart = searchItem.substr(0, index);
    const secondPart = searchItem.substr(index + 1, searchItem.length - index);
    checkList.push(`${firstPart}|${secondPart}`);
  }

  const suggestions = [];
  checkList.forEach(testElem => {
    mailProviders.forEach(_provider => {
      const provider = _provider.toLowerCase();
      const testParts = testElem.toLowerCase().split('|');
      const firstPart = provider.indexOf(testParts[0]);
      const secondPart = provider.indexOf(testParts[1]);
      if (firstPart !== -1 && secondPart !== -1 && suggestions.indexOf(provider) === -1) {
        suggestions.push(provider);
      }
    });
  });

  return suggestions;
}

export function htmlToText(element) {
  // If sended element has children, use them for conversion process; otherwise just use itself
  const elementList = element.childCount > 0 ? element.childElements() : [element];

  // Get text content of each element and merge them using new line
  const text = reduce(elementList, (prev, curr) => `${prev} ${curr.textContent.trim()}`, '');

  // Return trimmed text to avoid unnecessary spaces caused by reduce function
  return text.trim();
}

export function getSelectedRange() {
  if (global.getSelection) {
    const selection = global.getSelection();

    if (selection.getRangeAt && selection.rangeCount) {
      // Store each selection range
      const selectionState = [];
      for (let i = 0; i < selection.rangeCount; i++) {
        selectionState.push(selection.getRangeAt(i));
      }

      return selectionState;
    }
  } else if (global.selection && global.selection.createRange) {
    // Create selection range via createRange
    return global.selection.createRange();
  }

  // Nothing to do...
  return null;
}

export function setSelectionRange(selectionState) {
  if (selectionState) {
    if (global.getSelection) {
      const selection = global.getSelection();

      // Remove current selection
      if (document.body.createTextRange) { // All IE but Edge
        var range = document.body.createTextRange();
        range.collapse();
        range.select();
      } else {
        selection.removeAllRanges();
      }
      // Select saved selection instead
      forEach(selectionState, ch => selection.addRange(ch));
    } else if (global.document.selection && this.selectionState.select) {
      // Select directly by using createRange output
      selectionState.select();
    }
  }
}

export function findOne(haystack, arr) {
  return arr.some(el => haystack.indexOf(el) > -1);
}

export function findIndex(haystack, arr) {
  let index = -1;

  arr.some(el => {
    if (haystack.indexOf(el) > -1) {
      index = haystack.indexOf(el);
      return true;
    }

    return false;
  });

  return index;
}

export function triggerEvent(element, eventName) {
  if (document.createEvent) {
    const event = document.createEvent('HTMLEvents');
    event.initEvent(eventName, false, true);
    element.dispatchEvent(event);
  } else if (element.fireEvent) {
    element.fireEvent(`on${eventName}`);
  }
}

// enables or disables multiple or single dom elements
export function enableDisableDOMElements(elements, status) {
  const elementArray = typeof elements === typeof [] ? elements : [elements];
  forEach(elementArray, el => {
    if (!el) { return; }
    if (!status) {
      el.setAttribute('disabled', 'disabled');
    } else {
      el.removeAttribute('disabled');
    }
  });
}

// Returns orientation type from given angle, for old browsers
export function calculateOrientationType(angle = 0) {
  switch (angle) {
    case 90:
      return 'landscape-primary';
    case -90:
      return 'landscape-secondary';
    case 180:
      return 'portrait-secondary';
    default:
      return 'portrait-primary';
  }
}

// This will send given event to keen.io using jotform.com as a proxy.
// Only works on production
// Doesn't captures any response
export function sendAnalyticsData(formID, collectionName, jsonData, forceProduction = false) {
  const isProduction = forceProduction || global.location.href.indexOf('jotform.pro') === -1;
  const isPreviewMode = global.location.href.indexOf('?preview') !== -1;
  if (!collectionName || typeof jsonData !== 'object' || !global.XMLHttpRequest || !isProduction || isPreviewMode) {
    console.warn('Invalid usage');
  }
  const request = new global.XMLHttpRequest();
  const requestData = JSON.stringify({ ...jsonData, formID });
  try {
    request.open('POST', `https://www.jotform.com/stylebuilder/${formID}&action=sendAnalyticData&collection=${collectionName}&data=${encodeURIComponent(requestData)}`);
    request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
    request.send();
  } catch (err) {
    console.error(`Couldn't sent analytics data {${collectionName}: ${requestData}} .`, err);
  }
}

function translateItem(selector) {
  const item = selector; // For Eslint rule. Exp: https://eslint.org/docs/rules/no-param-reassign
  const formTranslation = global.FormTranslation;
  if (!formTranslation || !item) return false;

  const currentText = item.innerHTML;
  const originalElement = [...formTranslation.originalFormElements, ...formTranslation.originalDynamicFormElements].filter(p => p.element === item);

  const originalText = originalElement && originalElement[0] && originalElement[0].html;
  if (item && currentText && originalText) {
    const translation = formTranslation.translateCardTexts(originalText);
    item.innerHTML = translation ? translation : currentText;
  }
}

export function translateComponentFields(cards) {
  cards.forEach(card => card.question && card.question.componentClass && typeof card.question.componentClass.translate === 'function' && card.question.componentClass.translate());
}

export function translateDefaultCardFormTexts() {
  const formTranslation = global.FormTranslation;
  if (formTranslation) {
    const translateElements = [
      '.payment-text',
      '.cardProgress-goBack-text',
      '.cardProgress-seeAll',
      '.cardProgress-middleText',
      '.jfWelcome-sectionInfo-text',
      '.js-sacl-saved',
      '.js-sacl-valid-email',
      '.js-sacl-error',
      '.js-sacl-textarea',
      '.js-sacl-title',
      '.js-emailSent-feedback',
      '.js-saveContinueSendEmail',
      '.js-sacl-link',
      '.js-sacl-share',
      '.js-sacl-state-text',
      '.js-saveContinueTryAgain',
      '.jfUpload-button',
      '.jfUpload-heading .forDesktop',
      '.jfUpload-heading .forMobile',
      '.jfUpload-subheading .minFileSize',
      '.jfUpload-subheading .maxFileSize'
    ];
    forEach(translateElements, element => {
      let selector = null;

      if (element === '.payment-text') {
        selector = document.querySelectorAll(element);
      } else {
        selector = document.querySelector(element);
      }

      if (typeof selector === 'object' && selector !== null && selector.length !== undefined) {
        forEach(selector, item => {
          translateItem(item);
        });
      } else if (selector) {
        translateItem(selector);
      }
    });
  }
}

export function getBrowserProperties() {
  const browser = typeof window !== 'undefined' && bowser.getParser(window.navigator.userAgent);

  return ({
    osName: browser ? browser.getOSName() : '',
    browserName: browser ? browser.getBrowserName() : '',
    isAndroid: browser ? browser.isOS('android') : false,
    isWebkit: browser ? browser.isEngine('webkit') || browser.isEngine('blink') : false,
    isMobile: browser ? browser.isPlatform('mobile') : false,
    isTablet: browser ? browser.isPlatform('tablet') : false,
    browserVersion: browser ? browser.getBrowserVersion() : '',
    osVersion: browser ? browser.getOSVersion() : ''
  });
}

export function getDeviceType() {
  // for preview mode, if we set forceMobileDevice=1 lets force as mobile
  if (global.location && global.location.href.indexOf('&forceMobileDevice=1') > -1) {
    return 'Mobile';
  }

  const {
    isMobile, isTablet, osName, browserVersion, browserName
  } = getBrowserProperties();

  if (isMobile || isTablet) {
    return isMobile ? 'Mobile' : 'Tablet';
  }

  // Detect iPad devices for Safari 13 because of bowser's detecting issue
  const isSafari13 = osName === 'macOS'
    && browserVersion.split('.')[0] >= 13
    && browserName === 'Safari'
    && window.navigator
    && window.navigator.maxTouchPoints > 1;

  if (isSafari13) {
    return 'Tablet';
  }

  return 'Desktop';
}

export function replaceAll(input, str, newStr) {
  if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
    return input.replace(str, newStr);
  }
  return input.replace(new RegExp(str, 'g'), newStr);
}

export function parseQueryString(query) {
  const vars = query.split('&');
  const queryString = {};
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    const key = decodeURIComponent(pair.shift());
    const value = decodeURIComponent(pair.join('='));
    // If first entry with this name
    if (typeof queryString[key] === 'undefined') {
      queryString[key] = value;
      // If second entry with this name
    } else if (typeof queryString[key] === 'string') {
      const arr = [queryString[key], value];
      queryString[key] = arr;
      // If third or later entry with this name
    } else {
      queryString[key].push(value);
    }
  }
  return queryString;
}

export function isDST(d) {
  const jan = new Date(d.getFullYear(), 0, 1).getTimezoneOffset();
  const jul = new Date(d.getFullYear(), 6, 1).getTimezoneOffset();
  return Math.max(jan, jul) !== d.getTimezoneOffset();
}

export function getElementsByFocus({
  target,
  excludeAttributes = '',
  excludeStyles = {}
}) {
  if (!target || !(target instanceof HTMLElement)) return;
  const hasExcludedStyles = Object.keys(excludeStyles).length;
  const focusableElements = ['a[href]', 'button', 'input', 'textarea', 'select', 'details', 'iframe', '[tabindex]'];
  const notSelectors = ['[disabled]', ':disabled', '[hidden]', '.isHidden', '[type="hidden"]'].map(query => `:not(${query})`).join('');
  const focusableQuery = focusableElements.map(element => `${element}${notSelectors}`).join(',');
  const foundElements = [...target.querySelectorAll(focusableQuery)];
  return foundElements.filter(element => {
    if (element.offsetParent === null) return false; // offsetParent will return null if parent/element's display property is none.
    if (excludeAttributes) {
      const attributesArray = Array.isArray(excludeAttributes) ? excludeAttributes : [excludeAttributes];
      // if element includes 1 or more excluded attributes - return false;
      return !(attributesArray.some(attribute => element.hasAttribute(attribute)));
    }
    // if element includes 1 or more excluded styles - return false;
    if (hasExcludedStyles) return !(Object.entries(excludeStyles).some(([property, value]) => window.getComputedStyle(element)?.getPropertyValue(property) === value));
    return true;
  });
}
